import { Badge, Button, Col, Row } from 'react-bootstrap'
import { TagAttribute, TagModel } from '@editor/store/slices/tag.slice'
import { BsPencil, BsX } from 'react-icons/bs'
import React from 'react'

const TagList = ({
  handleEditTag,
  handleRemoveTag,
  editingTagIndex,
  tags,
  editable,
  indexPrefix,
}: {
  handleEditTag: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    tagToEdit: TagModel,
    tagIndex?: string
  ) => void
  handleRemoveTag: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    tagToRemove: TagModel
  ) => void
  editingTagIndex?: string
  tags: TagModel[] | undefined
  editable: boolean
  indexPrefix: string
}) => {
  const TagAttribute = ({ tagAttribute }: { tagAttribute: TagAttribute }) => (
    <Badge className="w-auto p-2 m-1" bg={'secondary'}>
      {`${tagAttribute.attributeName} = "${tagAttribute.attributeValue}"`}
    </Badge>
  )
  const Tag = ({
    tag,
    editable,
    index,
  }: {
    tag: TagModel
    editable: boolean
    index?: string
  }) => (
    <Row>
      <Col className="d-flex justify-content-start flex-wrap">
        <Badge className="w-auto m-1 p-2 " bg={'dark'}>
          {tag.tagName}
        </Badge>
        {tag.tagAttributes.map((tagAttribute: TagAttribute, attributeIndex) => (
          <Col className="flex-grow-0" key={attributeIndex}>
            <TagAttribute tagAttribute={tagAttribute}></TagAttribute>
          </Col>
        ))}
      </Col>
      <Col
        className="flex-grow-0 m-0 p-0"
        style={{
          minWidth: tag.tagAttributes.length > 0 && editable ? '72px' : '36px',
        }}
      >
        {editable && tag.tagAttributes.length > 0 && (
          <Button
            variant={editingTagIndex === index ? 'primary' : 'outline-primary'}
            size="sm"
            className="ms-1"
            onClick={(event) => handleEditTag(event, tag, index)}
          >
            <BsPencil></BsPencil>
          </Button>
        )}
        {editable && (
          <Button
            variant="outline-danger"
            size="sm"
            className="ms-1"
            onClick={(event) => handleRemoveTag(event, tag)}
          >
            <BsX></BsX>
          </Button>
        )}
      </Col>
    </Row>
  )
  return (
    <>
      {tags?.map((tag: TagModel, index) => (
        <Tag
          editable={editable}
          tag={tag}
          index={indexPrefix + index}
          key={indexPrefix + index}
        />
      ))}
    </>
  )
}

export default TagList
